import axios from "axios";
import defaultAxios from "./axios";
import MainStore from "@/store";
import MainRouter from "@/router";
import { getLoginRouteFromRole } from "@/mixins/LogoutMixin";

const { API_URL } = defaultAxios;

export const publicAxios = axios.create({
  baseURL: API_URL,
});

// Configuração do interceptor para tratar erros 401
publicAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Se o erro for 401 (Não autorizado)
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Redireciona para a página de login
      MainStore.dispatch("onboarding/requestLogout", false);
      const role = (MainStore as any).state?.profile?.me?.role;
      MainRouter.push({ name: getLoginRouteFromRole(role) });
      return Promise.reject(error);
    }
    // Para outros erros
    return Promise.reject(error);
  }
);
